export interface DataEntity_Main_03_Interface {
  id:number,
  calibration_id:number,
  filename:string,
  pdf_src:string,
  delivery_time:Number,
  manufacture:string,
  model:string,
  type:string,
  capability: string,

  unit_nomimal: string,
  unit_reference: string,
  unit_correction: string,
  unit_correction_eqution: string,
  unit_uncertainy: string,
  unit_working: string,
  unit_zfactor: string,

  fororaftegi: string,
  working_temp_min: string,
  working_temp_max: string,

   ////Mohit
   temperature_Air_before:string,
   temperature_Air_after:string,

   humidity_Air_before:string,
   humidity_Air_after:string,

   pressure_before:string,
   pressure_after:string,

}

export function Empty_DataEntity_Main_03_Interface():DataEntity_Main_03_Interface{
    return{
        id:0,
        calibration_id:0,
        filename:'',
        pdf_src:'',
        delivery_time: 0,
        manufacture:'',
        model:'',
        type:'',
        capability: '',

        unit_nomimal: '',
        unit_reference: '',
        unit_correction: '',
        unit_correction_eqution: '',
        unit_uncertainy: '',
        unit_working: '',
        unit_zfactor: '',


        fororaftegi: '',
        working_temp_min: '',
        working_temp_max: '',


        ////Mohit


        temperature_Air_before:'',
        temperature_Air_after:'',

        humidity_Air_before:'',
        humidity_Air_after:'',

        pressure_before:'',
        pressure_after:'',

    }
  }
